import { Pipe, PipeTransform } from '@angular/core';
import { TaskPaymentTypeEnum } from '@zaoblako/shared/modules/task/enum/task.payment.type.enum';

const paymentTypeNames: Record<TaskPaymentTypeEnum, string> = {
  [TaskPaymentTypeEnum.CASH]: 'Наличный',
  [TaskPaymentTypeEnum.BANK]: 'Безналичный'
};

@Pipe({
  standalone: true,
  name: 'paymentType'
})
export class PaymentTypePipe implements PipeTransform {
  public transform(type: TaskPaymentTypeEnum): string {
    return paymentTypeNames[type] || '';
  }
}
